// extracted by mini-css-extract-plugin
export default {"AppLayout__Page":"AppLayout_AppLayout__Page__C6sGQ"};